/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { FC } from 'react'
import LinkAtomic from '../../atomic/Link'
import styles from './Link.module.css'
import Text from './Text'

interface LinkProps {
  path: string
  external?: boolean
  target?: string
  text: string
  color?: string
  className?: string
}

const Link: FC<LinkProps> = ({
  path,
  external,
  target,
  text,
  color,
  className,
  ...props
}) => {
  const { clientId, LinkComponent } = useHeaderContext()

  const onClick = () => {
    trackEvent({
      eventName: 'custom_page_link_clicked',
      path,
      text,
      source: 'desktop',
      clientId,
    })
  }

  const linkStyle = {
    color: color ? `var(${color})` : '#616161',
  }

  const linkClassName = `${styles.link} ${className || ''}`

  if (LinkComponent && !external) {
    // Use custom Link component (e.g., Next.js Link)
    return (
      <LinkComponent
        href={path}
        className={linkClassName}
        style={linkStyle}
        onClick={onClick}
        {...props}
      >
        <Text text={text} color={color} />
      </LinkComponent>
    )
  }

  return (
    <LinkAtomic
      href={path}
      target={target}
      onClick={onClick}
      className={linkClassName}
      style={linkStyle}
    >
      <Text text={text} color={color} />
    </LinkAtomic>
  )
}

export default Link
